'use client';
import { lazy, Suspense, forwardRef, useRef, type ComponentProps, type ComponentRef } from 'react';
export type * from "/tmp/build-369/node_modules/@eliadmin/core/src/components/auth/sign-in-form.tsx";
export { signInSchema } from "@eliadmin/core/src/components/auth/sign-in-schema";
type Props = NonNullable<ComponentProps<typeof import("/tmp/build-369/node_modules/@eliadmin/core/src/components/auth/sign-in-form.tsx").SignInForm>>;
const Deferred = lazy(() => import("@eliadmin/module-original/signInForm").then(m => ({ default: m.SignInForm })));
export function SignInForm(props: Props) {  return <Suspense fallback={null}><Deferred {...props} /></Suspense>; }

